import React from "react";
import { ToastProvider } from "../../Contexts/Toast/toast.provider";
import { ModalProvider } from "../../Contexts/Modal/modal.provider";

const GlobalModule = ({ children }) => {
  return (
    <ToastProvider>
      <ModalProvider>{children}</ModalProvider>
    </ToastProvider>
  );
};

export default GlobalModule;
